import { Input } from '@/components/ui/input';
import { PreVisitQuestionLabel } from './PreVisitQuestionLabel';
import type { PreVisitQuestionRendererProps } from './preVisitQuestionRendererProps';

export function NumberRenderer({ question, value, isInvalid, onChange }: PreVisitQuestionRendererProps) {
  const resolvedValue = typeof value === 'string' ? value : '';
  const inputId = 'pre-visit-question-' + question.code;

  return (
    <div className="space-y-1.5">
      <PreVisitQuestionLabel question={question} htmlFor={inputId} />
      <Input
        id={inputId}
        type="number"
        inputMode="decimal"
        value={resolvedValue}
        hasError={isInvalid}
        onChange={function change(changeEvent) {
          onChange(changeEvent.target.value);
        }}
      />
    </div>
  );
}
